import React from 'react'
import { Helmet } from "react-helmet";
import PageTitle from '../../pagetitle/PageTitle'

export default function Iletisim() {
  const title = "OKAF İletişim - Samsun Üniversitesi";
  const description = "Samsun Üniversitesi ev sahipliğinde gerçekleşecek olan Orta Karadeniz Kariyer Fuarı (OKAF)'ın iletişim bilgilerine ulaşmak için tıklayınız!";
  return (
    <>
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
      </Helmet>
      <PageTitle name="İletişim"></PageTitle>
      <div class="container">
        <div class="iletisimPage p-3 mb-3">
          <div class="row main">
            <div class="col-md-4 left mt-4">
              <div class="colums">
                <div class="icon"><i class="bi bi-geo-alt-fill"></i></div>
                <div class="detail">
                  <div class="head">Adres:</div>
                  <div class="body">Zafer Mahallesi Cumhuriyet Cad. No:33 Kent Müzesi Yanı, 55060 İlkadım/Samsun</div>
                </div>
              </div>
              <div class="colums">
                <div class="icon"><i class="bi bi-telephone-fill"></i></div>
                <div class="detail">
                  <div class="head">Telefon:</div>
                  <div class="body">0 (539) 349 39 55</div>
                </div>
              </div>
              <div class="colums">
                <div class="icon"><i class="bi bi-envelope-fill"></i></div>
                <div class="detail">
                  <div class="head">Mail:</div>
                  <div class="body">okaf@samsun.edu.tr</div>
                </div>
              </div>
            </div>
            <div class="col-md-8 right">
              <div class="map">
                <div class="iframe">
                  <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2998.0134793134653!2d36.33666317647317!3d41.286811102227006!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x408877e7bf4c9a33%3A0x5910ada30b4f9f08!2zU2Ftc3VuIMOcbml2ZXJzaXRlc2kgUmVrdMO2cmzDvMSfw7wgxZ5laGlyIE9maXNp!5e0!3m2!1str!2str!4v1699090655280!5m2!1str!2str" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
